<template>
  <div class="verify-popup">
    <div class="verify-popup-popBox">
      <div class="verify-popup-title">{{title}}</div>
      <el-select v-if="transfer" v-model="value" placeholder="请选择转移的公司" class="verify-popup-txt" style="border: none">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.companyName"
          :value="item.id">
        </el-option>
      </el-select>
      <textarea v-else class="verify-popup-txt" v-model.trim="value" :maxlength=maxlength :placeholder="placeholder"></textarea>
      <div class="verify-popup-btnBox">
        <button class="verify-popup-cancel" @click="cancel">{{$t('btns.cancel')}}</button>
        <button class="verify-popup-submit" @click="confirm">{{$t('btns.confirm')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VerifyPopup",
  props: ["title", "maxlength", "placeholder","transfer","options"],
  data() {
    return {
      value: ''
    };
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm(){
      this.$emit('confirm', this.value)
    }
  },
  created(){}
};
</script>

<style lang="scss" scoped>
  // Placeholder text
  @mixin placeholder($color: $input-color-placeholder) {
    // Firefox
    &::-moz-placeholder {
      color: $color;
      opacity: 1; // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526
    }
    &:-ms-input-placeholder { color: $color; } // Internet Explorer 10+
    &::-webkit-input-placeholder  { color: $color; } // Safari and Chrome
  }

  .verify-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  &-popBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 440px;
    height: 335px;
    transform: translate(-50%, -50%);
    background: #fff;
  }
  &-title {
    text-align: center;
    color: #fff;
    height: 70px;
    font-size: 18px;
    line-height: 70px;
    background: #40404d;
  }
  &-txt {
    box-sizing: border-box;
    display: block;
    margin: 15px auto;
    width: 390px;
    height: 160px;
    padding: 10px;
    resize: unset;
    border: 1px solid #e9ebf0;
    border-radius: 2px;
    font-size: 14px;
    @include placeholder(#D1D0D8);
  }
  &-btnBox {
    width: 390px;
    height: 70px;
    margin: 15px auto;
    box-shadow: inset 0 1px 0 0 #eaeaea;
    button {
      width: 150px;
      height: 38px;
      margin: 15px 22px;
      outline: none;
      cursor: pointer;
      border-radius: 2px;
    }
  }
  &-submit {
    color: #fff;
    background: #7996f5;
  }
  &-submit:hover {
    background: #8ca6fd;
  }
  &-cancel {
    border: 1px solid #e9ebf0;
    color: #666;
    background: #fff;
  }
  &-cancel:hover {
    color: #6985df;
    border: 1px solid #6985df;
  }

}
</style>

